import React, { useEffect, useMemo } from "react"
import { Container } from "reactstrap"
import { getOrders, getPendingOrders } from "../../api"
import TableContainer from "../../components/Common/TableContainer"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"

function PendingOrders({ t }) {
  const [orders, setOrders] = React.useState([])
  useEffect(() => {
    getPendingOrders().then(res => {
      console.log(res)
      setOrders(res)
    })
  }, [])
  const columns = useMemo(
    () => [
      {
        header: t("Number"),
        accessorKey: "orderNumber",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: t("Created At"),
        accessorKey: "createdDate",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ cell }) => {
          const date = new Date(cell.getValue())
          return date.toLocaleDateString() + " " + date.toLocaleTimeString()
        },
      },

      {
        header: t("Type"),
        accessorKey: "orderType",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ cell }) => {
          const orderType = cell.getValue()
          return orderType.toUpperCase();
        }
      },
      {
        header: t("Status"),
        accessorKey: "status",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ cell }) => {
          const status = cell.getValue();
          let bgColor = "transparent";
          if (status === "finished") {
            bgColor = "green";
          } else if (status === "created") {
            bgColor = "orange";
          } else if (status === "cancelled") {
            bgColor = "red";
          } else if (status === "expired") {
            bgColor = "blue";
          }
          return (
            <span style={{ backgroundColor: bgColor, padding: "0.2em 0.5em", borderRadius: "4px", color: "white" }}>
              {t(status)}
            </span>
          );
        }
      },
      {
        header: t("User ID"),
        accessorKey: "userId",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: t("Actions"),
        id: "actions",
        cell: ({ row }) => (
          <button
            className="btn btn-sm btn-primary"
            onClick={() => openOrderInNewTab(row)}
          >
            {t("View")}
          </button>
        ),
      },
    ],
    [t]
  )
  function openOrderInNewTab(row) {
    console.log(row)
    const orderId = row.original.id
    const orderUrl = `/orders/${orderId}`
    window.open(orderUrl, "_blank")
  }
  return (

    <div>
      <h2>{t("Pending orders")}</h2>
      <TableContainer
      handleUserClick={openOrderInNewTab}
      columns={columns}
      data={orders || []}
      isGlobalFilter={true}
      isCustomPageSize={true}
      isPagination={true}
      SearchPlaceholder={orders.length + " " + t("records") + "..."}
      pagination="pagination"
      paginationWrapper="dataTables_paginate paging_simple_numbers"
      tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
    /></div>
  )
}

PendingOrders.propTypes = {
  t: PropTypes.func.isRequired,
}

export default withTranslation()(PendingOrders)
